import { minBy } from 'lodash';
import { isDefined } from '../../../ts-utils';
export const getViewportCenterY = () => document.documentElement.clientHeight / 2 + document.documentElement.scrollTop;
export const findClosestBox = (boxes, centerY) => {
    const boxesWithDistance = [...boxes.values()]
        .map((box) => {
        const node = box.getElementRef();
        if (node) {
            const rect = node.getBoundingClientRect();
            const boxCenterY = rect.height / 2 + rect.top + window.scrollY;
            return {
                ...box,
                node,
                distance: Math.abs(centerY - boxCenterY),
            };
        }
        return undefined;
    })
        .filter(isDefined);
    return minBy(boxesWithDistance, (b) => b.distance);
};
export const focusWithRetry = (focus) => {
    let retries = 10;
    let retry_interval = 100;
    const falloff = 50;
    const interval = setInterval(() => {
        if (focus() === 'focus_initiated') {
            clearInterval(interval);
        }
        else {
            retries--;
            retry_interval += falloff;
            if (retries === 0) {
                clearInterval(interval);
            }
        }
    }, retry_interval);
};
//# sourceMappingURL=root-box-effect-provider.utils.js.map